export default "__VITE_ASSET__BCNmzvV5__"